import { createApiClient } from '@wix/premium-fed-sdk/apis-infra-react';
import { DoublePurchaseQueriesConfig } from './double-purchase.config';
export const DoublePurchaseApiClient = createApiClient(DoublePurchaseQueriesConfig);
//# sourceMappingURL=double-purchase.api-client.js.map